import { render, staticRenderFns } from "./TheLayoutContent.vue?vue&type=template&id=65b2cab9&"
import script from "./TheLayoutContent.vue?vue&type=script&lang=js&"
export * from "./TheLayoutContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b2cab9')) {
      api.createRecord('65b2cab9', component.options)
    } else {
      api.reload('65b2cab9', component.options)
    }
    module.hot.accept("./TheLayoutContent.vue?vue&type=template&id=65b2cab9&", function () {
      api.rerender('65b2cab9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/TheLayoutContent.vue"
export default component.exports